module.exports = __webpack_public_path__ + "img/pinnjcourt.23acb86e.png";